import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Collapse, Icon } from '@chakra-ui/react';
import { InfoCircleFill } from '@styled-icons/bootstrap/InfoCircleFill';
import { ChevronDown } from '@styled-icons/entypo/ChevronDown';
import {
  BannerContainer,
  BannerHeader,
  BannerHeaderLeft,
  BannerBody,
} from './ToteChangesBanner.styles';

export const ToteChangesBanner = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <BannerContainer data-cy="toteChangesBanner">
      <BannerHeader
        onClick={() => setIsOpen((prev) => !prev)}
        role="button"
        aria-expanded={isOpen}
      >
        <BannerHeaderLeft>
          <Icon as={InfoCircleFill} boxSize={4} />
          <FormattedMessage id="racing.raceDetails.toteChangesBanner.heading" />
        </BannerHeaderLeft>
        <Icon
          as={ChevronDown}
          boxSize={4}
          transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
          transition="transform 0.2s"
        />
      </BannerHeader>
      <Collapse in={isOpen} animateOpacity>
        <BannerBody>
          <FormattedMessage id="racing.raceDetails.toteChangesBanner.body" />
        </BannerBody>
      </Collapse>
    </BannerContainer>
  );
};

export default ToteChangesBanner;
